const initialState = {
    showingAddHomepageItemModal: false,
    addingHomepageItemToColumnId: null,
    addingHomepageItemToSectionId: null,
    addingHomepageItem: false
};

export default initialState;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/initialState.js